$.fn.ExtendingList = function() {
  let self = this

  const INITIAL_MAX_HEIGHT = 0

  self.find('.js-extending-list__panel').each(function() {
    let accordionPanel = $(this)

    accordionPanel.sizer = function() {
      let textContent = accordionPanel.find('.js-extending-list__panel__content')
      let outerHeight = textContent.outerHeight(false)
      accordionPanel.css('max-height', outerHeight > INITIAL_MAX_HEIGHT ? outerHeight + 'px' : '')
    }

    $(window).on('resize load orientationchange', accordionPanel.sizer)
    accordionPanel.sizer()
  });

  self.find('.js-extending-list__toggler').click(function() {
    if($(this).closest('.js-extending-list__item').hasClass('js-extending-list__item--open')){
      $(this).closest('.js-extending-list__item').removeClass('js-extending-list__item--open');
    }else{
      self.find('.js-extending-list__item').removeClass('js-extending-list__item--open');
      $(this).closest('.js-extending-list__item').addClass('js-extending-list__item--open');
    }
  });

  return function() {
    return self
  }()
}
